import { CutleryIcon } from "@/components/icons/cutlery-icon";
import { memo } from "react";
import { CurvedArrow } from "../my-plan-add-guide";

interface MyPlanEmptyStateProps {
  /** Opens the NutriCoach chat in general (day-level) mode. */
  onAddNext: () => void;
}

/**
 * Empty-day state for My Plan v2 (Figma 1171:3910). The arrow directs the user
 * toward the Coach button while remaining tappable as a shortcut to the same
 * day-level coach flow.
 */
export const MyPlanEmptyState = memo(function MyPlanEmptyState({
  onAddNext,
}: MyPlanEmptyStateProps) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center px-6 pb-10 text-center">
      <div className="bg-os-brand/10 text-os-brand flex h-[90px] w-[90px] items-center justify-center rounded-full [&_path]:fill-current">
        <CutleryIcon className="h-10 w-10" />
      </div>

      <h2
        className="mt-5 max-w-[310px] text-[22px] leading-[27px] font-semibold text-black"
        style={{
          fontFamily: "var(--font-crimson-text)",
          fontFeatureSettings: '"liga" 0, "clig" 0',
        }}
      >
        Here’s where <span className="text-os-brand italic">any food</span>
        <br />
        <span className="text-os-brand italic">you eat</span> will be tracked
      </h2>

      <p
        className="mt-6 max-w-[270px] text-[13px] leading-[18px] font-medium text-black/60"
        style={{ fontFamily: "var(--font-urbanist)" }}
      >
        Log meals in seconds. Just say <br />
        what you’ve eaten or take a photo.
      </p>

      <button
        type="button"
        aria-label="Open Coach"
        onClick={onAddNext}
        className="mt-8 flex h-[62px] w-11 items-center justify-center"
      >
        <CurvedArrow className="h-[62px] w-[18px]" />
      </button>
    </div>
  );
});
